import { createStore } from 'effector';

export const $investProRegions = createStore([]);

export const $investProDistricts = createStore([]);

export const $investProDots = createStore([]);
